import { PrivateRoute } from 'components'
import React, { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const StoreInfo = lazy(() => import('../pages/B2B/StoreInfo'))
const WaitingVerification = lazy(() =>
  import('../pages/B2B/WaitingVerification'),
)
const Checkout = lazy(() => import('../pages/B2B/Checkout'))
const Cart = lazy(() => import('../pages/B2B/Cart'))
const Complimentary = lazy(() => import('../pages/B2B/Complimentary'))

const Idle = [
  {
    path: '/store-info',
    element: <StoreInfo />,
  },
  {
    path: '/waiting-verification',
    element: <WaitingVerification />,
  },
  {
    path: '*',
    element: <Navigate to={'/store-info'} replace />,
  },
]

const Waiting = [
  {
    path: '/store-info',
    element: <StoreInfo />,
  },
  {
    path: '/waiting-verification',
    element: <WaitingVerification />,
  },
  {
    path: '*',
    element: <Navigate to={'/waiting-verification'} replace />,
  },
]

const Main = [
  {
    path: '/checkout/*',
    element: <Checkout />,
  },
  {
    path: '/cart/*',
    element: <Cart />,
  },
  {
    path: '/complimentary',
    element: <Complimentary />,
  },
  {
    path: '*',
    element: <Navigate to={'/store'} replace />,
  },
]

export default { Main, Idle, Waiting }
